class StoreUtils {
  static setJson(key, json) {
    localStorage.setItem(key, JSON.stringify(json));
  }

  static getJson(key) {
    if (!key) {
      return null;
    }
    return JSON.parse(localStorage.getItem(key));
  }

  static setToken(token) {
    return StoreUtils.setJson("im_token", token);
  }

  static getToken() {
    return StoreUtils.getJson("im_token");
  }

  static getAccessToken() {
    return StoreUtils.getJson("im_token").access_token;
  }



}

export default StoreUtils;
